import { deleteCookie, getCookie, setCookie } from '@/lib/utils/cookies';

const SESSION_ACTIVE_ORG_ID = 'active-org-id';
export const COOKIE_TEMP_ORG_ID = 'temp-org-id';

const domain = process.env.NEXT_PUBLIC_COOKIE_DOMAIN;

export function setTempOrgIdCookie(orgId: string): void {
  setCookie(COOKIE_TEMP_ORG_ID, orgId, domain);
}

export function deleteTempOrgIdCookie(): void {
  deleteCookie(COOKIE_TEMP_ORG_ID, domain);
}

export function readTempOrgIdCookie(): string | null {
  return getCookie(COOKIE_TEMP_ORG_ID);
}

export function readSessionActiveOrgId(): string | null {
  if (typeof window === 'undefined') return null;

  const stored = sessionStorage.getItem(SESSION_ACTIVE_ORG_ID);
  if (stored) {
    return stored;
  }

  const cookieValue = readTempOrgIdCookie();
  if (cookieValue) {
    sessionStorage.setItem(SESSION_ACTIVE_ORG_ID, cookieValue);
  }
  return cookieValue;
}

type WriteOptions = {
  persistCookie?: boolean;
};

export function setSessionActiveOrgId(orgId: string, { persistCookie = true }: WriteOptions = {}): void {
  if (typeof window === 'undefined') {
    return;
  }

  sessionStorage.setItem(SESSION_ACTIVE_ORG_ID, orgId);

  if (persistCookie) {
    setTempOrgIdCookie(orgId);
  } else {
    deleteTempOrgIdCookie();
  }
}

export function setSessionActiveOrgFromCookie(): void {
  if (typeof window === 'undefined') {
    return;
  }

  const cookieValue = readTempOrgIdCookie();
  if (cookieValue) {
    setSessionActiveOrgId(cookieValue, { persistCookie: false });
  }
}

export function clearSessionActiveOrgId(): void {
  if (typeof window === 'undefined') {
    return;
  }

  sessionStorage.removeItem(SESSION_ACTIVE_ORG_ID);
  deleteTempOrgIdCookie();
}
